/**
 * The manager PIN field a STAFF session fills for a money override (DNKADM-0375 /
 * DNKAPI-0670): a cancel with Full or None, or a custom no-show fee. Same input as the
 * comp PIN (digits only, masked, never autofilled); the server checks it, the console
 * never learns the PIN. Required whenever it is shown.
 */
import { TextField, type SxProps, type Theme } from '@mui/material';
import { useManagerPinInputProps } from '@/components/useManagerPinInputProps';

export function ManagerPinField({
  value,
  onChange,
  disabled,
  error,
  sx,
}: {
  value: string;
  onChange: (pin: string) => void;
  disabled: boolean;
  /** The server's PIN refusal, shown under the field. */
  error: string | null;
  sx?: SxProps<Theme>;
}) {
  const pinInputProps = useManagerPinInputProps(value, onChange);
  return (
    <TextField
      label="Manager PIN"
      required
      fullWidth
      size="small"
      {...pinInputProps}
      disabled={disabled}
      error={error !== null}
      helperText={error ?? 'Staff need a manager to enter the PIN for this.'}
      {...(sx !== undefined ? { sx } : {})}
    />
  );
}
